const data = {
  body: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path d="M4 6H20M4 12H20M13 18H20" stroke="#141618" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n</svg>',
  width: 24,
  height: 24
}
export default data
